"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Returns float representing the percentage of a value between a min and max.
// Clips return value between 0.0 ~ 1.0 (inclusive)
// percentBetweenValues(15, 10, 20) -> 0.50
// percentBetweenValues(100, 10, 20) -> 1.00
var percentBetweenValues = function percentBetweenValues(value, min, max) {
  return value <= min ? 0 : value >= max ? 1 : (value - min) / (max - min);
};

var _default = percentBetweenValues;
exports["default"] = _default;